module.exports = __webpack_public_path__ + "static/img/yxl_half_consult_banner.8ddf5e4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/yxl_half_consult_banner.gif
// module id = 9ScX
// module chunks = 156